import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatterService } from 'ngx-hijri-gregorian-datepicker';
import { DateStruct } from 'src/app/models/DatePickerModel';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html'
})

export class DatepickerComponent implements OnInit, OnChanges {
  @Input() label: string = this.translate.instant('forms.Date');
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() controlName!: string;
  @Input() isSubmitted!: boolean;
  @Input() required!: boolean;
  @Input() disabled!: boolean;
  @Input() min: any; // Date or DateStruct
  @Input() max: any; // Date or DateStruct
  @Input() invalidMsg!: string;
  @Input() showToday = true;
  @Input() placement!: string;

  @Output() selectedDateChanged = new EventEmitter<any>();
  @Output() ageValue = new EventEmitter<any>();

  // date: NgbDate;
  isHijri!: boolean;
  @Input() selectedDate!: any; //DateStruct-- NgbDateStruct

  minDate!: {
    gregorian: NgbDateStruct,
    hijri: NgbDateStruct
  };
  maxDate!: {
    gregorian: NgbDateStruct,
    hijri: NgbDateStruct
  };

  today = this.calendar.getToday();
  isTouched = false;

  constructor(
    private calendar: NgbCalendar,
    private translate: TranslateService,
    private dateFormatterService: DateFormatterService
  ) { }

  ngOnInit(): void {
    if (!this.min) { this.min = new Date('1/1/1938'); }
    // else { this.min = new Date(this.min); }
    if (this.max) { this.max = new Date(this.max); }
    this.setMinMax();

    this.isHijri = false;
    if (this.controlName && this.formGroup.controls[this.controlName].value) {
      this.selectedDate = this.tongbDate(this.formGroup.controls[this.controlName].value);
    }
    if (this.selectedDate) {
      this.selectedDate = this.tongbDate(this.selectedDate);
      this.setFieldControlValue();
    } else {
      this.selectedDate = new DateStruct();
    }
    if (this.controlName) {
      this.formGroup.controls[this.controlName].valueChanges.subscribe(value => {
        this.selectedDate = this.tongbDate(value);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    let min = this.min; let max = this.max;
    // if (changes.min) { min = changes.min.currentValue; }
    // if (changes.max) { max = changes.max.currentValue; }
    this.setMinMax(min, max);
    this.ckechValid();
  }

  setMinMax(min = this.min, max = this.max) {
    min = this.tongbDate(min);
    max = this.tongbDate(max);
    this.minDate = {
      gregorian: (min && min.isHijri) ? this.dateFormatterService.ToGregorian(min) : min,
      hijri: (min && min.isHijri) ? min : this.dateFormatterService.ToHijri(min)
    };
    this.maxDate = {
      gregorian: (max && max.isHijri) ? this.dateFormatterService.ToGregorian(max) : max,
      hijri: (max && max.isHijri) ? max : this.dateFormatterService.ToHijri(max)
    };
  }

  ckechValid() {
    let ctrVal = this.formGroup.controls[this.controlName].value;
    if (ctrVal) {
      if (ctrVal.isHijri) { ctrVal = this.dateFormatterService.ToGregorian(ctrVal); }
      const date = new NgbDate(ctrVal.year, ctrVal.month, ctrVal.day);
      if (date.before(this.minDate.gregorian) || date.after(this.maxDate.gregorian)) {
        this.formGroup.controls[this.controlName].setErrors({invalid: true});
      } else {
        this.formGroup.controls[this.controlName].setErrors(null);
      }
    }
  }

  tongbDate(date: any) {
    if (typeof(date) === 'string') { date = new Date(date); }
    if (date instanceof Date && date.getTime()) {
      return { day: date.getUTCDate(), month: date.getUTCMonth() + 1, year: date.getUTCFullYear(), isHijri: false };
    } else {
      return date;
    }
  }

  changeDateType(isHijri: boolean) {
    if (this.isHijri !== isHijri) {
      this.isHijri = isHijri;

      if (this.selectedDate && this.selectedDate.day) {
        if (this.isHijri) {
          this.selectedDate = this.dateFormatterService.ToHijri(this.selectedDate);
        } else {
          this.selectedDate = this.dateFormatterService.ToGregorian(this.selectedDate);
        }
        this.setFieldControlValue();
      }
      this.ckechValid();
    }
  }

  setFieldControlValue() {
    if (this.selectedDate && this.selectedDate.day) {
      this.selectedDate.isHijri = this.isHijri;
    }
    if (this.controlName) {
      this.formGroup.controls[this.controlName].setValue(this.selectedDate);
    }

    this.selectedDateChanged.emit(this.selectedDate);
    this.calculateAge();
  }
  setDate(selected: DateStruct|null = null) {
    this.selectedDate = selected;
    this.setFieldControlValue();
  }
  hasError(errorName: string|null = null) {
    if (this.isSubmitted || this.isTouched) {
      if (this.controlName) {
        if (!errorName) { return this.formGroup.controls[this.controlName].invalid; }
        else { return this.formGroup.controls[this.controlName].hasError(errorName); }
      }
      else { return !this.selectedDate; }
    }
    return false;
  }
  calculateAge() {
    let currentDate = this.selectedDate;
    let Age = 0;
    if (currentDate) {
      if (this.isHijri) {
        currentDate = this.dateFormatterService.ToGregorian(this.selectedDate);
      }
      const birthday = new Date(currentDate.year, currentDate.month - 1, currentDate.day);
      const ageDifMs = Date.now() - birthday.getTime();
      const ageDate = new Date(ageDifMs);
      Age = Math.abs(ageDate.getUTCFullYear() - 1970);
    }
    this.ageValue.emit(Age);
  }
}
